import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { take, takeUntil } from 'rxjs/operators';

interface NotificationsOptions {
    id?: string;
    message: string;
    messageParam?: any;
    mobileMessage?: string;
    icon?: string;
    duration?: number;
}

@Injectable({providedIn: 'root'})
export class NotificationsController {
    private notificationList = [];
    activeNotification = null;

    constructor(private snackBar: MatSnackBar,
                private translate: TranslateService) {
    }

    create(options: NotificationsOptions): void {
        const message = options.mobileMessage != null ? options.mobileMessage : options.message;
        this.translate
            .get(message, options.messageParam)
            .pipe(take(1))
            .subscribe((translated: string) => {
                if (this.activeNotification != null) {
                    this.notificationList.push({message: translated});
                } else {
                    this.showNotification(translated);
                }
            });
    }

    showSomethingWentWrong(handleRetry: () => void = null, error = null): void {
        this.notificationList = [];
        this.translate
            .get(['NOTIFICATIONS.SOMETHING_WENT_WRONG', 'LABELS.RETRY'])
            .pipe(take(1))
            .subscribe((translated: string[]) => {
                const snackBarRef = this.snackBar.open(translated['NOTIFICATIONS.SOMETHING_WENT_WRONG'], handleRetry != null ? translated['LABELS.RETRY'] : null, {
                    duration: 10000
                });
                this.activeNotification = snackBarRef;
                snackBarRef.onAction()
                    .pipe(takeUntil(snackBarRef.afterDismissed()))
                    .subscribe(() => {
                        if (!!handleRetry) {
                            handleRetry();
                        }
                        snackBarRef.dismiss();
                        this.checkForNextNotification();
                    });
                snackBarRef.afterDismissed()
                    .pipe(take(1))
                    .subscribe(() => {
                        this.checkForNextNotification();
                    });
            });
    }

    private showNotification(message: string) {
        const snackBarRef = this.snackBar.open(message, null, {
            duration: 10000
        });
        this.activeNotification = snackBarRef;
        snackBarRef.afterDismissed()
            .pipe(take(1))
            .subscribe(() => {
                this.checkForNextNotification();
            });
    }

    private checkForNextNotification() {
        this.activeNotification = null;
        if (this.notificationList.length > 0) {
            const notification = this.notificationList.shift();
            this.showNotification(notification.message);
        }
    }
}
